export default __webpack_public_path__ + "static/media/higher_brand_arrow_down.9b4fdce9.svg";